import { isEmail } from 'validator'

export const isEmailValid = (email) => email.length > 0 && isEmail(email) 
